/**
 * External dependencies.
 */
import PropTypes from 'prop-types';
import React from 'react';
import { useStaticQuery, graphql } from "gatsby"

/**
 * Internal dependencies.
 */
import { Header } from "./header-static";

/**
 * Default Header Component Export.
 *
 * @return {*}
 */
export default ( props ) => {

	const data = useStaticQuery(graphql`
		query HeaderQuery {
			wp {
				generalSettings {
					language
				}
			}
			langMenu: allWpMenuItem(
				filter: {locations: {eq: WP_LANGUAGES_MENU}}
			) {
				nodes {
					id
					title: label
					cssClasses
					uri
					parentId
				}
			}
		}
	`)

	return (
		<Header lang={props.lang} langReplace={props.langReplace} data={ data } className={props.className} breadcrumbs={props.breadcrumbs} />
	)
}

Header.propTypes = {
	siteTitle: PropTypes.string,
};

Header.defaultProps = {
	data: {
		wp: {},
		categories: {}
	},
};
